import { EnvironmentInjector, Injectable, Type, inject } from '@angular/core';
import { OverlayHandle, OverlayRole, OverlayService } from './overlay.service';

export interface MpModalOptions {
	component: Type<any>;
	componentProps?: Record<string, any>;
	cssClass?: string | string[];
	backdropDismiss?: boolean;
	showBackdrop?: boolean;
	animated?: boolean;
	/** Aceitos por compat com o Ionic; sem efeito no motor próprio. */
	swipeToClose?: boolean;
	keyboardClose?: boolean;
	mode?: 'ios' | 'md';
	id?: string;
	presentingElement?: any;
}

/**
 * Drop-in do ModalController do @ionic/angular (create/present/dismiss/onDidDismiss + dismiss/getTop do topo).
 *
 * `providedIn: 'any'` e não `'root'`, de propósito: no Ionic o `ModalController` é provido pelo
 * `IonicModule` em CADA módulo que o importa, e o `create()` monta o componente do modal com o
 * `EnvironmentInjector` desse módulo (`angularDelegate.create(this.environmentInjector, …)`). O
 * modal enxerga os providers do módulo lazy da página que o abriu. Com uma instância só na raiz,
 * todo modal nascia no injector raiz: o `LaddaModule.forRoot({ style: 'zoom-out' })` das telas
 * de endereço era ignorado, valia o `style: 'contract'` do CoreModule, e o botão CONFIRMAR
 * encolhia numa elipse verde ao calcular a taxa (QA OP-1075, C49). `'any'` dá uma instância por
 * injector de módulo lazy — o mesmo escopo do IonicModule. A pilha continua uma só: quem a
 * guarda é o `OverlayService`, que é raiz.
 */
@Injectable({ providedIn: 'any' })
export class MpModalController {
	private environmentInjector = inject(EnvironmentInjector);

	constructor(private overlay: OverlayService) {}

	create(opts: MpModalOptions): Promise<OverlayHandle> {
		return Promise.resolve(
			this.overlay.create({
				kind: 'modal',
				component: opts.component,
				componentProps: opts.componentProps,
				cssClass: opts.cssClass,
				backdropDismiss: opts.backdropDismiss,
				showBackdrop: opts.showBackdrop,
				animated: opts.animated,
				environmentInjector: this.environmentInjector,
			}),
		);
	}

	dismiss(data?: any, role?: OverlayRole): Promise<boolean> {
		return this.overlay.dismissTop(data, role, 'modal');
	}

	getTop(): Promise<OverlayHandle | undefined> {
		return Promise.resolve(this.overlay.getTop('modal'));
	}
}
